(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8779);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3838);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/A1+Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    size = props.size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
Icon.defaultProps = {
  screenReaderContent: null,
  developmentUrl: null,
  className: null,
  size: 24
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 1257:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(287);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1491);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

/***/ }),

/***/ 1680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Generates a random number
 *
 * @param {number} [min=10000] - the minimum number for generatation
 * @param {number} [max=99999] - the maxiumum number for generatation
 *
 * @returns {number} random number between min and max
 */
var randomNum = function randomNum() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;
  var randomNumber = Math.random() * (max - min) + min;
  return Math.floor(randomNumber);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (randomNum);

/***/ }),

/***/ 4184:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 1491:
/***/ (() => {



/***/ }),

/***/ 4490:
/***/ (() => {



/***/ }),

/***/ 8779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 3838:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Select)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(8779);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(3838);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(1257);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(997);
;// CONCATENATED MODULE: ./src/_partials/LabelWithOptionalText/index.tsx



var LabelWithOptionalText = function LabelWithOptionalText(_ref) {
  var label = _ref.label,
    required = _ref.required,
    _ref$wrapWithLabelEle = _ref.wrapWithLabelElement,
    wrapWithLabelElement = _ref$wrapWithLabelEle === void 0 ? true : _ref$wrapWithLabelEle,
    id = _ref.id;
  var LabelText = function LabelText() {
    return /*#__PURE__*/(0,jsx_runtime_.jsxs)(jsx_runtime_.Fragment, {
      children: [label, " ", required ? '' : '(optional)']
    });
  };
  if (wrapWithLabelElement) {
    return /*#__PURE__*/(0,jsx_runtime_.jsx)("label", {
      htmlFor: id,
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)(LabelText, {})
    });
  } else {}
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(LabelText, {});
};
/* harmony default export */ const _partials_LabelWithOptionalText = (LabelWithOptionalText);
// EXTERNAL MODULE: ./src/_helpers/randomNum.ts
var randomNum = __webpack_require__(1680);
;// CONCATENATED MODULE: ./src/TextField/validationInlineMessage.tsx



var ValidationInlineMessage = function ValidationInlineMessage(props) {
  var id = props.id,
    variant = props.variant,
    developmentUrl = props.developmentUrl,
    validationInlineText = props.validationInlineText;
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("p", {
    id: id,
    className: "able-validation-inline--".concat(variant, " able-validation-inline--Show"),
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
      icon: variant,
      screenReaderContent: variant,
      developmentUrl: developmentUrl
    }), validationInlineText ? validationInlineText : "Your application is missing the 'validationInlineText' prop."]
  });
};
/* harmony default export */ const validationInlineMessage = (ValidationInlineMessage);
;// CONCATENATED MODULE: external "@babel/runtime/helpers/toConsumableArray"
const toConsumableArray_namespaceObject = require("@babel/runtime/helpers/toConsumableArray");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_namespaceObject);
;// CONCATENATED MODULE: ./src/_helpers/isValidErrorMessageProp.ts


var allowedElementTypes = ['span', 'string', 'Symbol(react.fragment)'];
var parseChildrenToFindNonSpanElements = function parseChildrenToFindNonSpanElements(children, listOfElements) {
  external_react_namespaceObject.Children.map(children, function (child) {
    if (! /*#__PURE__*/(0,external_react_namespaceObject.isValidElement)(child)) {
      return '';
    }
    if (child.props.children) {
      var props = {
        children: parseChildrenToFindNonSpanElements(child.props.children, listOfElements)
      };
      child = /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(child, props);
    }
    listOfElements.push(child.type.toString());
    return child.type.toString();
  });
  return listOfElements;
};
var isValidErrorMessageProp = function isValidErrorMessageProp(children) {
  var listOfElements = [];
  parseChildrenToFindNonSpanElements(children, listOfElements);
  var listOfDisallowedElementsForErrorMessaging = listOfElements.filter(function (elementType) {
    return !allowedElementTypes.includes(elementType);
  });
  if (listOfDisallowedElementsForErrorMessaging.length) {
    listOfDisallowedElementsForErrorMessaging = listOfDisallowedElementsForErrorMessaging.map(function (element) {
      return "<".concat(element, ">");
    });
    var disallowedElementsForErrorMessagingAsAString = toConsumableArray_default()(new Set(listOfDisallowedElementsForErrorMessaging)).join(', ');
    var errorMessage = listOfDisallowedElementsForErrorMessaging.length > 1 ? "Elements ".concat(disallowedElementsForErrorMessagingAsAString, " are not allowed") : "Element ".concat(disallowedElementsForErrorMessagingAsAString, " is not allowed");
    return {
      isValidErrorMessage: false,
      invalidErrorMessagePropErrorText: errorMessage
    };
  }
  return {
    isValidErrorMessage: true,
    invalidErrorMessagePropErrorText: ''
  };
};
var throwErrorIfInvalidErrorMessageProp = function throwErrorIfInvalidErrorMessageProp(errorMessageProp, errorMessagePropName) {
  var _isValidErrorMessageP = isValidErrorMessageProp(errorMessageProp),
    isValidErrorMessage = _isValidErrorMessageP.isValidErrorMessage,
    invalidErrorMessagePropErrorText = _isValidErrorMessageP.invalidErrorMessagePropErrorText;
  if (!isValidErrorMessage) {
    throw new Error("".concat(invalidErrorMessagePropErrorText, " for ").concat(errorMessagePropName, ". Please provide a string or a span element. Nested spans are allowed for accessibility purposes."));
  }
};

;// CONCATENATED MODULE: ./src/Select/Select.tsx


var _excluded = ["allowEmpty", "className", "defaultValue", "developmentUrl", "events", "helpText", "invalid", "invalidMessage", "label", "options", "required", "size", "id", "value", "showValidationInline", "validationInlineVariant", "validationInlineText", "disableFirstOption"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









/**
 * A Select input allows the user to choose between a number of options, presented in a list.
 *
 * [View the Select pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/A1+Select)
 *
 * @version 1.0.0
 */
var Select = /*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(function (props, ref) {
  var allowEmpty = props.allowEmpty,
    className = props.className,
    defaultValue = props.defaultValue,
    developmentUrl = props.developmentUrl,
    events = props.events,
    helpText = props.helpText,
    invalid = props.invalid,
    invalidMessage = props.invalidMessage,
    label = props.label,
    options = props.options,
    required = props.required,
    size = props.size,
    id = props.id,
    value = props.value,
    showValidationInline = props.showValidationInline,
    validationInlineVariant = props.validationInlineVariant,
    validationInlineText = props.validationInlineText,
    disableFirstOption = props.disableFirstOption,
    other = objectWithoutProperties_default()(props, _excluded);
  var filteredDefaultValue = disableFirstOption && defaultValue === undefined && value === undefined ? '' : defaultValue;
  var patternClass = 'able-Select';
  var classes = classnames_default()(patternClass, "".concat(patternClass, "--").concat(size), className);
  var emptyOptionObj = [{
    value: '',
    label: 'Select…'
  }];
  var combinedOptions = allowEmpty ? emptyOptionObj.concat(options) : options;
  var elementId = id || "ableSelect".concat((0,randomNum["default"])());
  var errorTextId = "".concat(elementId, "__error-text");
  var helpTextId = "".concat(elementId, "__help-text");
  var validationInlineTextId = "".concat(id, "__validation-inline-text");
  var getAriaDescribedByIds = function getAriaDescribedByIds() {
    if (invalid || showValidationInline || helpText) {
      return "".concat(invalid ? errorTextId : '').concat(!invalid && showValidationInline ? validationInlineTextId : '').concat((invalid || showValidationInline) && helpText ? ' ' : '').concat(helpText ? helpTextId : '');
    }
    return undefined;
  };
  if (invalidMessage) {
    throwErrorIfInvalidErrorMessageProp(invalidMessage, 'invalidMessage');
  }
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", _objectSpread(_objectSpread({
    className: classes
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_LabelWithOptionalText, {
      label: label,
      required: required,
      id: id
    }), helpText ? /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
      id: helpTextId,
      children: helpText
    }) : null, /*#__PURE__*/(0,jsx_runtime_.jsx)("select", _objectSpread(_objectSpread({
      id: id,
      ref: ref,
      name: id,
      defaultValue: filteredDefaultValue,
      "aria-required": required,
      "aria-invalid": invalid || undefined,
      "aria-describedby": getAriaDescribedByIds()
    }, events), {}, {
      value: value,
      children: combinedOptions.map(function (option, index) {
        return /*#__PURE__*/(0,jsx_runtime_.jsx)("option", {
          value: option.value,
          disabled: index === 0 && disableFirstOption ? true : undefined,
          children: option.label
        }, option.value);
      })
    })), invalid ? /*#__PURE__*/(0,jsx_runtime_.jsxs)("p", {
      id: "".concat(id, "__error-text"),
      className: "".concat(patternClass, "__error"),
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
        icon: "Error",
        screenReaderContent: "Error",
        developmentUrl: developmentUrl
      }), invalidMessage]
    }) : '', !invalid && showValidationInline && validationInlineVariant ? /*#__PURE__*/(0,jsx_runtime_.jsx)(validationInlineMessage, {
      id: validationInlineTextId,
      variant: validationInlineVariant,
      developmentUrl: developmentUrl,
      validationInlineText: validationInlineText
    }) : null]
  }));
});
Select.defaultProps = {
  invalid: undefined,
  developmentUrl: undefined,
  className: undefined,
  defaultValue: undefined,
  events: undefined,
  allowEmpty: true,
  required: true,
  invalidMessage: 'Required selection.',
  size: 'Auto',
  disableFirstOption: false
};
Select.displayName = 'Select';
/* harmony default export */ const Select_Select = (Select);
// EXTERNAL MODULE: ./src/Select/Select.scss
var src_Select_Select = __webpack_require__(4490);
;// CONCATENATED MODULE: ./src/Select/index.ts


/* harmony default export */ const src_Select = (Select_Select);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});